export default {
  fallbackLocale: process.env.DEFAULTLANGUAGE ?? 'en',
  detectBrowserLanguage: false,
  numberFormats: {
    de: {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
      },
    },
    en: {
      currency: {
        style: 'currency',
        currency: 'EUR',  // NK Set to EUR as default currency for English
        currencyDisplay: 'symbol',
      },
    },
    bg: {
      currency: {
        style: 'currency',
        currency: 'BGN',
        currencyDisplay: 'symbol',
      },
    },
    fr: {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
      },
    },
    it: {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
      },
    },
    es: {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
      },
    },
    tr: {
      currency: {
        style: 'currency',
        currency: 'TRY',
        currencyDisplay: 'symbol',
      },
    },
    nl: {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
      },
    },
    pl: {
      currency: {
        style: 'currency',
        currency: 'PLN',
        currencyDisplay: 'symbol',
      },
    },
    pt: {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
      },
    },
    no: {
      currency: {
        style: 'currency',
        currency: 'NOK',
        currencyDisplay: 'symbol',
      },
    },
    ro: {
      currency: {
        style: 'currency',
        currency: 'RON',
        currencyDisplay: 'symbol',
      },
    },
    da: {
      currency: {
        style: 'currency',
        currency: 'DKK',
        currencyDisplay: 'symbol',
      },
    },
    sv: {
      currency: {
        style: 'currency',
        currency: 'SEK',
        currencyDisplay: 'symbol',
      },
    },
    cs: {
      currency: {
        style: 'currency',
        currency: 'CZK',
        currencyDisplay: 'symbol',
      },
    },
    ru: {
      currency: {
        style: 'currency',
        currency: 'RUB',
        currencyDisplay: 'symbol',
      },
    },
    sk: {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
      },
    },
    zh: {
      currency: {
        style: 'currency',
        currency: 'CNY',
        currencyDisplay: 'symbol',
      },
    },
    vi: {
      currency: {
        style: 'currency',
        currency: 'VND',
        currencyDisplay: 'symbol',
      },
    },
    fi: {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
      },
    },
    ga: {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
      },
    },
    lt: {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
      },
    },
    lv: {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
      },
    },
    et: {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
      },
    },
    hr: {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'symbol',
      },
    },
    hu: {
      currency: {
        style: 'currency',
        currency: 'HUF',
        currencyDisplay: 'symbol',
      },
    },
  },
};
